import {AppLanguageTag} from '../../i18n/types';
import {AppConfig, LegalDocuments} from '../../interfaces/app-config';

export function getTranslatedLegalDocuments(
  legalDocuments: AppConfig['legalDocuments'],
  language: string
): LegalDocuments {
  const docs = legalDocuments[language as AppLanguageTag];

  if (!docs) {
    // Fallback.
    console.warn(
      `Legal documents not found for language ${language}. Using default language (pt_PT).`
    );
    return legalDocuments.pt_PT;
  }

  return docs;
}
